/**
 * Device Fingerprinting Utility – Web
 * Matches mobile implementation (e.g., React Native) by normalizing screen pixels.
 */

// FNV-1a Hash (32-bit)
const fnv1aHash = (str) => {
  let hash = 2166136261;
  for (let i = 0; i < str.length; i += 1) {
    hash ^= str.charCodeAt(i); // eslint-disable-line no-bitwise
    hash = (hash * 16777619) >>> 0; // eslint-disable-line no-bitwise
  }
  return hash.toString(16).padStart(8, '0');
};


const getNormalizedTimezone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz.toLowerCase().trim();
  } catch {
    const offset = new Date().getTimezoneOffset();
    const hours = Math.abs(Math.floor(offset / 60));
    const minutes = Math.abs(offset % 60);
    const sign = offset <= 0 ? '+' : '-';
    return `utc${sign}${hours.toString().padStart(2, '0')}${minutes
      .toString()
      .padStart(2, '0')}`;
  }
};

const getNormalizedLanguage = () => {
  try {
    const lang = navigator.language || navigator.userLanguage || 'en';
    return lang.split('-')[0].toLowerCase().trim();
  } catch {
    return 'en';
  }
};

const getNormalizedPlatform = () => {
  try {
    const ua = navigator.userAgent.toLowerCase();
    const platform = navigator.platform?.toLowerCase() || '';
    if (ua.includes('iphone') || ua.includes('ipad') || platform.includes('iphone')) return 'ios';
    if (ua.includes('android')) return 'android';
    if (ua.includes('windows') || platform.includes('win')) return 'windows';
    if (ua.includes('mac') || platform.includes('mac')) return 'mac';
    if (ua.includes('linux') || platform.includes('linux')) return 'linux';
    return 'unknown';
  } catch {
    return 'unknown';
  }
};

const generateFingerprintString = () => {
  const timezone = getNormalizedTimezone();
  const language = getNormalizedLanguage();
  const platform = getNormalizedPlatform();

  const fp = `${timezone}|${language}|${platform}`;
  console.log('🔍 Fingerprint Components:', { 
    timezone, 
    language, 
    platform
  });
  console.log('📌 Fingerprint String (minimal):', fp);
  return fp;
};

const generateDeviceFingerprint = () => {
  const raw = generateFingerprintString();
  const hash = fnv1aHash(raw);
  console.log('✅ Device Fingerprint:', { raw, hash });
  return { raw, hash };
};

const storeFingerprint = async (deepLinkUrl, backendUrl) => {
  try {
    const { hash } = generateDeviceFingerprint();
    const payload = {
      deepLinkUrl,
      fingerprint: hash,
    };

    const response = await fetch(`${backendUrl}/links/storage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const result = await response.json();
    console.log('✅ Stored fingerprint:', result);
    return true;
  } catch (err) {
    console.error('❌ Failed to store fingerprint:', err);
    return false;
  }
};

export {
  fnv1aHash,
  generateFingerprintString,
  generateDeviceFingerprint,
  storeFingerprint,
};
